import styled from "styled-components";

export const LanguageFlag = styled("img")`
  position: relative;
  width: 25px;
  height: 19px;
`;
